import { IntegrationActions } from './IntegrationActions.mjs';

const integrationReducer = (state, action) => {
  switch (action.type) {
    case IntegrationActions.SALESFORCE_SUBMIT_STARTED: {
      return {
        ...state,
        salesforceStatus: {
          isProcessing: true,
          isCompleted: false
        }
      };
    }

    case IntegrationActions.SALESFORCE_SUBMIT_COMPLETED: {
      return {
        ...state,
        salesforceStatus: {
          isProcessing: false,
          isCompleted: true
        }
      };
    }

    case IntegrationActions.SALESFORCE_REQUEST_FAILED: {
      return {
        ...state,
        salesforceStatus: {
          isProcessing: false,
          isCompleted: false
        }
      };
    }

    default:
      return state;
  }
};

export default integrationReducer;
